// extracted by mini-css-extract-plugin
export default {"control-box":"yF5N5dw_PjD3Y1u","left-control-box":"E4UJmSCUWeaLl3S","right-control-box":"dCIskNbK_9YFLRb","transparent":"hiCem1JZwePFj0b"};